import React, { Component } from 'react';
import { Breadcrumb } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
// import { Box } from 'reactjs-admin-lte'
import ReportJobControlBoard from '../../report/ReportJobControlBoard'
import WorkJobEdit from './WorkJobEdit'
import {connect} from 'react-redux'
import PMBoardTable from '../pmcontrol/PMBoardTable';
class WorkJobControlPage extends Component {

  constructor(...args) {
    super(...args)
    this.state = { showReport: true,workNo:'' }

    this.jobControl = null
  }

  onRowClick(row,workState) {
    this.setState(
      { showReport: false,workNo:row.work_no }, () => {
        if(this.props.control=='workJob')
          this.refs.jobEdit.getWrappedInstance().loadWorkJob(row,workState)
      })
  }

  onStateChange(workNo, taskstate) {
    if(this.jobControl!==null)
      this.jobControl.updateWorkNo(workNo, taskstate)

    this.setState({workNo:workNo})
  }

  renderBreadcumb(){
    const {workNo} = this.state
    let {messages} = this.props
    return (
      <Breadcrumb>
        <Breadcrumb.Item href="#" onClick={()=>{this.setState({ showReport: true },()=>{
          this.jobControl.loadWorkList()
        })}}><FontAwesome name="table"/> {messages['Work Job Control Table']}</Breadcrumb.Item>
        <Breadcrumb.Item href="#">
          <FontAwesome name='file-o'/> {messages['Work No']} {workNo}
        </Breadcrumb.Item>            
      </Breadcrumb>      
    )    
  }

  renderPMBoard(){
    if(!this.state.showReport){
      return (<PMBoardTable workNo={this.state.workNo}/>  )
    }else{
      return (<div/>)
    }
  }

  render() {
    let { showReport } = this.state
    return (
      <div>
        <ReportJobControlBoard onRef={(ref)=>{this.jobControl = ref}} onBack={()=>{this.setState({ showReport: true },()=>{
          this.jobControl.loadWorkList()
        })}} show={showReport} control={this.props.control} onRowClick={this.onRowClick.bind(this)} />
        {(!showReport) && this.renderBreadcumb()}
        {this.props.control=='workJob'?(<WorkJobEdit ref='jobEdit' show={!showReport}
          onStateChange={this.onStateChange.bind(this)}
          onClose={() => { this.setState({ showReport: true },()=>{
            this.jobControl.loadWorkList()
          }) }} />):(
          this.renderPMBoard()
          )}
      </div>
    )
  }
}

WorkJobControlPage.defaultProps = {
  control:'workJob',  
}

export default WorkJobControlPage = connect(
  (state) => ({messages: state.message.view.workdoc.jobcontrol.WorkJobControlPage}),null,null,{withRef:true}
)(WorkJobControlPage);





// WEBPACK FOOTER //
// ./src/view/workdoc/jobcontrol/WorkJobControlPage.js